// campaign_selection_controller.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        "info",
        "campaignName",
        "submitButton",
        "button",
        "campaignInput",
        "summaryRow",
        "summaryName",
        "summaryPrice",
        "plusPrice",
        "totalPrice",
    ];
    static values = {
        recurrentJob: String,
        csrfToken: String,
        addUrl: String,
        campaignOptional: Boolean,
    };

    connect() {
        console.log("Campaign selection controller connected for job:", this.recurrentJobValue);
    }

    selectCampaign(event) {
        const card = event.currentTarget;
        const isCurrentlySelected = card.classList.contains("selected");

        // Helper function to format price
        const formatPrice = (price) => `${price} EUR`;
        const formatCampaignPrice = (price) => `${price},00 EUR`;

        // First, reset all cards
        this.element.querySelectorAll("[data-campaign]").forEach((card) => {
            card.classList.remove("selected");

            const button = card.querySelector("button");
            button.textContent = "Auswählen";
        });

        if (isCurrentlySelected) {
            // Hide info text
            const infoText = this.infoTarget.querySelector("p");
            infoText.classList.add("tw-opacity-0");

            // Always disable the "Jetzt buchen" button when deselecting
            this.submitButtonTarget.disabled = true;
            this.submitButtonTarget.classList.add("is-disabled");

            // Hide campaign summary row if it exists
            if (this.hasSummaryRowTarget) {
                this.summaryRowTarget.classList.remove("tw-flex");
                this.summaryRowTarget.classList.add("tw-hidden");
            }

            // Reset total price if it exists
            if (this.hasTotalPriceTarget && this.hasPlusPriceTarget) {
                const plusPrice = this.plusPriceTarget.textContent.split(" ")[0];
                this.totalPriceTarget.textContent = formatPrice(plusPrice);
            }

            // Clear selected campaign
            this.selectedCampaign = undefined;

            if (this.hasCampaignInputTarget) {
                this.campaignInputTarget.value = "";
            }

            return;
        }

        // Select the clicked card
        card.classList.add("selected");

        const button = card.querySelector("button");
        button.textContent = "Ausgewählt";

        // Update campaign info
        const campaignName = card
            .querySelector("h4")
            .innerHTML.replace(/<br\s*\/?>/i, " ")
            .trim();
        this.campaignNameTarget.textContent = campaignName;

        // Update summary section if it exists
        if (this.hasSummaryNameTarget && this.hasSummaryPriceTarget && this.hasSummaryRowTarget) {
            const campaignPrice = card.querySelector(".tw-text-2xl").textContent.split(" ")[0];
            this.summaryNameTarget.textContent = campaignName;
            this.summaryPriceTarget.textContent = formatCampaignPrice(campaignPrice);
            this.summaryRowTarget.classList.remove("tw-hidden");
            this.summaryRowTarget.classList.add("tw-flex");

            // Update total price if it exists
            if (this.hasTotalPriceTarget && this.hasPlusPriceTarget) {
                const plusPrice = parseFloat(this.plusPriceTarget.textContent.split(" ")[0].replace(",", "."));
                const campaignPriceFloat = parseFloat(campaignPrice.replace(",", "."));
                const total = (plusPrice + campaignPriceFloat).toFixed(2).replace(".", ",");
                this.totalPriceTarget.textContent = formatPrice(total);
            }
        }

        // Show info by removing opacity
        const infoText = this.infoTarget.querySelector("p");
        infoText.classList.remove("tw-opacity-0");

        // Always enable the "Jetzt buchen" button when selecting
        this.submitButtonTarget.disabled = false;
        this.submitButtonTarget.classList.remove("is-disabled");

        // Store selected campaign value and update hidden input
        this.selectedCampaign = card.dataset.campaign;
        if (this.hasCampaignInputTarget) {
            // Update all campaign inputs with the selected value
            this.campaignInputTargets.forEach((input) => {
                input.value = this.selectedCampaign ?? "";
            });
        }
    }

    submit() {
        console.log("Submit url is " + this.addUrlValue);
        if (this.selectedCampaign !== undefined) {
            fetch(this.addUrlValue, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: new URLSearchParams({
                    campaignProduct: this.selectedCampaign,
                }),
            })
                .then((response) => {
                    if (response.ok) {
                        // Close selection modal
                        const closeButton = this.element.querySelector('[data-dismiss="modal"]');
                        closeButton.click();

                        // Show confirmation modal and set up reload on hide
                        const confirmationModal = $(`#campaign-confirmation-modal-${this.recurrentJobValue}`);
                        confirmationModal.on("hidden.bs.modal", () => {
                            window.location.reload();
                        });
                        confirmationModal.modal("show");
                    } else {
                        console.error("Failed to add campaign");
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    }
}
